import { capitalize } from '@gonfalon/strings/capitalize';

import { getExperimentApprovalAction } from './getExperimentApprovalAction';
import type { ApprovalRequest } from './records/ApprovalRequest';

export const getApprovalAppliedNotificationMessage = (updatedApproval: ApprovalRequest) => {
  const readableResourceKind = capitalize(updatedApproval.getReadableResourceKindName());

  if (updatedApproval.status === 'failed') {
    return `${readableResourceKind} update failed.`;
  }
  if (updatedApproval.instructions.isEmpty()) {
    return 'Scheduled changes deleted';
  }
  if (updatedApproval.executionDate) {
    return 'Changes scheduled';
  }
  const experimentAction = getExperimentApprovalAction(updatedApproval);
  if (experimentAction) {
    return `Experiment ${experimentAction}`;
  }
  return `Changes applied. ${readableResourceKind} updated.`;
};
